import { types } from "../../types/types";

const initialState = {
  loading: false,
  estadosLegales:[],
  areasLegales: [],
};

export const contratacionesLegalesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.contratacionesTraerEstadosLegalesStart:
    return {
      ...state,
      loading: true
    }
    case types.contratacionesTraerEstadosLegalesSuccess:
      return {
        ...state,
        estadosLegales: action.payload,
      }
    case types.contratacionesTraerEstadosLegalesError:
      return {
        ...state,
        estadosLegales: [],
        loading: false
      }
    case types.contratacionesTraerAreasLegalesStart:
      return {
        ...state,
        loading: true
      }
    case types.contratacionesTraerAreasLegalesSuccess:
      return {
        ...state,
        areasLegales: action.payload,
      }
    case types.contratacionesTraerAreasLegalesError:
      return {
        ...state,
        areasLegales: [],
        loading: false
      }
    default:
      return state;
  }
};